export const GamePeriodsTypes = {
    "SCHEDULED":{
        id:"SCHEDULED",
        title:"در حال برنامه ریزی"
    },
    "REGISTRATION_OPEN":{
        id:"REGISTRATION_OPEN",
        title:"در حال ثبت نام"
    },
    "IN_PROGRESS":{
        id:"IN_PROGRESS",
        title:"در حال برگزاری"
    },
    "COMPLETED":{
        id:"COMPLETED",
        title:"تمام شده"
    },
    "CANCELLED":{
        id:"CANCELLED",
        title:"لغو شده"
    },

}